<div class="modal-body"  style="animation: 300ms ease-out 0s 1 normal forwards running zoom-in;">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
       {{
        enumService.getEnumerationText(
          UiOEModel.oe_enmName_OETyp,
          UiOEModel.oe_enmIdent_OETyp
        )
	    }} {{excSecurity.isFeatured('CRMEDIT') ? data.new ? getGlobal('create') : getGlobal('edit') : ''}}
    </span>
		<div *ngIf="!isLoading"
      class="content grid-1-auto height-800">
			<div class="layout-auto-1 content width-400" style="margin-right: 1rem">
        <h6 class="grid-1-auto">Stammdaten
          <i class="search-action fa-regular fa-pencil"
             *ngIf="!visibilityController.showContactEditor && !visibilityController.showAddressEditor && excSecurity.isFeatured('CRMEDIT')"
             [ngClass]="{'fa-pencil': !visibilityController.showOEEditor, 'fa-times': visibilityController.showOEEditor}"
             (click)="toggleOEEditor()">
          </i></h6>
				<div class="layout-auto-1-auto">
					<div class="content">
						<app-exg-select-enumeration *ngIf="!enmIdentOETypIsPredefined"
                                        [caption]="enumService.getFieldCaption('OE', 'oe_enmIdent_OETyp')"
						                            [(value)]="UiOEModel.oe_enmIdent_OETyp"
                                        (valueChange)="disabledController.checkIfOESavable()"
						                            [disabled]="!visibilityController.showOEEditor"
                                        [enumerationList]="OETypEnumList"
						>
						</app-exg-select-enumeration>
						<ng-container *ngIf="enumService.getEnumerationText(
                              UiOEModel.oe_enmName_OETyp,
                              UiOEModel.oe_enmIdent_OETyp
                          ) === 'Person'">
							<app-exg-select-enumeration [caption]="enumService.getFieldCaption('OE', 'oe_enmIdent_AnredeTyp')"
							                            [(value)]="UiOEModel.oe_enmIdent_AnredeTyp"
                                          (valueChange)="disabledController.checkIfOESavable()"
							                            [disabled]="!visibilityController.showOEEditor"
							                            enumerationName="AnredeTyp"
							>
							</app-exg-select-enumeration>
							<exg-input [(ngModel)]="UiOEModel.oeNPraefix"
                         (ngModelChange)="disabledController.checkIfOESavable()"
							           disabled="{{!visibilityController.showOEEditor}}"
							           [caption]="enumService.getFieldCaption('OE', 'oeNPraefix')">
							</exg-input>
						</ng-container>
						<exg-input [(ngModel)]="UiOEModel.oeName"
                       (ngModelChange)="disabledController.checkIfOESavable()"
						           disabled="{{!visibilityController.showOEEditor}}"
						           [caption]="enumService.getEnumerationText(
                                        UiOEModel.oe_enmName_OETyp,
                                        UiOEModel.oe_enmIdent_OETyp
                                    ) === 'Person' ?
                                        enumService.getFieldCaption('OE', 'oeName')
                                        : enumService.getFieldCaption('Organisation', 'BEZ')">
						</exg-input>
						<exg-input [(ngModel)]="UiOEModel.oeEName"
                       (ngModelChange)="disabledController.checkIfOESavable()"
						           disabled="{{!visibilityController.showOEEditor}}"
						           [caption]="enumService.getFieldCaption('OE', 'oeEName')"
						           *ngIf="enumService.getEnumerationText(
                              UiOEModel.oe_enmName_OETyp,
                              UiOEModel.oe_enmIdent_OETyp
                          ) === 'Person'">
						</exg-input>
						<exg-input [(ngModel)]="UiOEModel.oeNPraefix"
                       (ngModelChange)="disabledController.checkIfOESavable()"
						           disabled="{{!visibilityController.showOEEditor}}"
						           [caption]="enumService.getFieldCaption('Organisation', 'KBZ')"
						           *ngIf="enumService.getEnumerationText(
                              UiOEModel.oe_enmName_OETyp,
                              UiOEModel.oe_enmIdent_OETyp
                          ) !== 'Person'">
						</exg-input>
						<app-exg-select-enumeration *ngIf="!crmRolleIsPredefined"
                                        [caption]="enumService.getFieldCaption('OE', 'oe_CrmRolle')"
						                            [(value)]="UiOEModel.oe_CrmRolle"
                                        (valueChange)="disabledController.checkIfOESavable()"
						                            [disabled]="!visibilityController.showOEEditor"
						                            [enumerationName]="UiOEModel.oe_enmIdent_OETyp === 2 ? 'CrmRollePerson' : 'CrmRolleOrganisation'"
						>
						</app-exg-select-enumeration></div>
					<div class="spawn-reverse" *ngIf="visibilityController.showOEEditor">
						<button (click)="toggleOEEditor()"
						        class="md-btn">
							{{getGlobal('Cancel')}}
						</button>
						<button (click)="saveOEEditor()"
                    [disabled]="disabledController.oeSavingDisabled"
						        class="md-btn">
							{{getGlobal('Save')}}
						</button>
					</div>
				</div>
			</div>
      <div class="content width-500">
        <div class="layout-auto-1"
             [ngStyle]="{'max-height': !visibilityController.showContactEditor ? '50%' : '100%'}"
             *ngIf="!visibilityController.showAddressEditor">
          <h6 class="grid-1-auto">Kontaktmöglichkeit
            <i class="search-action fa-regular fa-plus"
               *ngIf="!visibilityController.showOEEditor && !this.data.new && excSecurity.isFeatured('CRMEDIT')"
               [ngClass]="{'fa-plus': !visibilityController.showContactEditor, 'fa-times': visibilityController.showContactEditor}"
               (click)="visibilityController.changeContactEditor()"></i></h6>
          <div class="content">
            <ng-container *ngIf="!visibilityController.showContactEditor">
              <div class="list-row list-row-1-auto app-cursor-pointer"
                   (click)="visibilityController.changeContactEditor(index)"
                   *ngFor="let contact of ContactsList.data; index as index">
                <div class="list-primary-text">
                  {{contact.kontVal}}
                </div>
                <div>
									<span class="list-metadata typo-right">
										{{
                    enumService.getEnumerationText(
                      contact.kont_enmName_KontaktTyp,
                      contact.kont_enmIdent_KontaktTyp
                    )
                    }}
									</span>
                </div>
              </div>
	            <div class="splash empty" *ngIf="ContactsList.data.length === 0"><p>Keine Kontakte</p></div>
            </ng-container>
            <ng-container *ngIf="visibilityController.showContactEditor">
              <div class="layout-1-auto">
                <div class="content grid cols-3">
                  <app-exg-select-enumeration #VCrcptTyp
                                              [(value)]="ContactsList.oeContactClone.kont_enmIdent_KontaktTyp"
                                              [caption]="enumService.getFieldCaption('Kontakt', 'kont_enmIdent_KontaktTyp')"
                                              enumerationName="KontaktTyp"
                                              name="type">
                  </app-exg-select-enumeration>

                  <exg-input #VCContactValue
                             [(ngModel)]="ContactsList.oeContactClone.kontVal"
                             [caption]="enumService.getFieldCaption('Kontakt', 'kontVal')"
                             class="span-2">
                  </exg-input>
                </div>
                <div class="spawn-reverse">
                  <button (click)="visibilityController.changeContactEditor()"
                          class="md-btn">
                    {{getGlobal('Cancel')}}
                  </button>
                  <button (click)="contactAction({del: true})"
                          class="md-btn">
                    {{getGlobal('Delete')}}
                  </button>
                  <button (click)="contactAction()"
                          class="md-btn">
                    {{getGlobal('Save')}}
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="layout-auto-1"
             [ngStyle]="{'max-height': !visibilityController.showAddressEditor ? '50%' : '100%'}"
             *ngIf="!visibilityController.showContactEditor">
          <h6 class="grid-1-auto">Adresse
            <i class="search-action fa-regular fa-plus"
               *ngIf="!visibilityController.showOEEditor && !this.data.new && excSecurity.isFeatured('CRMEDIT')"
               [ngClass]="{'fa-plus': !visibilityController.showAddressEditor, 'fa-times': visibilityController.showAddressEditor}"
               (click)="visibilityController.changeAddressEditor()">
            </i></h6>
          <div class="content">
            <ng-container *ngIf="!visibilityController.showAddressEditor">
              <div class="list-row list-row-1-auto app-cursor-pointer"
                   (click)="visibilityController.changeAddressEditor(index)"
                   *ngFor="let address of AddressesList.data; index as index">
                <div>
                  <div class="list-primary-text">
                    {{address.adrStr}} {{address.adrHNum}}
                  </div>
                </div>
                <div>
	                  <span class="list-metadata typo-right">
											{{
                      enumService.getEnumerationText(
                        address.adr_enmName_AdresseTyp,
                        address.adr_enmIdent_AdresseTyp
                      )
                      }}
	                  </span>
                </div>
                <div>
                  <div class="list-secondary-text">
                    {{address.adrLkz}} - {{address.adrPlz}} {{address.adrOrt}}
                  </div>
                </div>
                <div></div>
              </div>
	            <div class="splash empty" *ngIf="AddressesList.data.length === 0"><p>Keine Adressen</p></div>
            </ng-container>
            <ng-container *ngIf="visibilityController.showAddressEditor">
              <div class="layout-1-auto">
                <div class="content">
                  <div class="grid" *ngIf="!showManuel">
                    <ng-container *ngIf="!locActive">
                      <p class="typo-inline-info" style="margin-top: 0.5rem">
                        <i class="far fa-info-circle"></i>
                        <span>
                      <ul class="typo-small" style="overflow: hidden; white-space: break-spaces;">
                        <li>{{getRessource('HelpTextWelcome')}}</li>
                        <li>{{getRessource('HelpTextSearch')}}</li>
                        <li>{{getRessource('HelpTextOverview')}}</li>
                        <li>{{getRessource('HelpTextDetails')}}</li>
                      </ul>
                      </span>
                      </p>

                      <div class="md-typeahead-container" style="margin: 1rem;">
                        <app-searchbar (search)="onSearch($event)" placeholder="{{getRessource('LocationSearchPlaceholder')}}"></app-searchbar>
                        <div class="md-typeahead-menu" *ngIf="placesList.length > 0">
                          <ng-container *ngFor="let value of placesList;let i = index">
	                          <span (click)="onResultClick(i)"
                                  class="md-typeahead-menu-item">{{value?.placePrediction?.text?.text}}</span>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="locActive">
                      <div class="grid cols-2" style="margin: 0.5rem">
                        <div class="grid-1-auto address-display">
                          <div class="panel">
                            <strong>{{AddressesList.oeAddressClone.adrPlaceName}}</strong>
                            <div>{{AddressesList.oeAddressClone.adrStr }} {{AddressesList.oeAddressClone.adrHNum}}</div>
                            <div>
                              <span>{{AddressesList.oeAddressClone.adrPlz }}</span>
                              <span> {{AddressesList.oeAddressClone.adrOrt }}</span>
                            </div>
                            <div>{{AddressesList.oeAddressClone.adrLand }}</div>
                          </div>

                          <div class="grid grid-auto-1">
                            <button class="md-btn-quickedit" style="margin-right: .5rem"  (click)="changeManuel()">
                              <i class="far fa-pencil"></i>
                            </button>
                            <button class="md-btn-quickedit" (click)="resetSearch()">
                              <i class="far fa-trash"></i>
                            </button>
                          </div>
                        </div>

                        <div style="overflow: hidden; border: 1px solid var(--c-dark-m1); border-radius: 0.5rem; height: 200px">
                          <exg-map class="hideprints hidelogo" [latitude]="AddressesList.oeAddressClone.adrLat" [longitude]="AddressesList.oeAddressClone.adrLng"
                                   [(zoom)]="MapZoom"
                                   [disableDefaultUI]="true">
                            <exg-map-marker [latitude]="AddressesList.oeAddressClone.adrLat " [longitude]="AddressesList.oeAddressClone.adrLng">
                            </exg-map-marker>
                          </exg-map>
                        </div>
                      </div>

                      <ng-container *ngIf="!predefinedAddressType">
                        <app-exg-select-enumeration #VCrcptTyp
                                                    [required]="true"
                                                    [(value)]="AddressesList.oeAddressClone.adr_enmIdent_AdresseTyp"
                                                    [caption]="enumService.getFieldCaption('Adresse', 'AdresseTyp')"
                                                    enumerationName="AdresseTyp"
                                                    name="type"
                                                    class="span-6">
                        </app-exg-select-enumeration>
                      </ng-container>

                      <exg-textarea [(ngModel)]="AddressesList.oeAddressClone.adrBez"
                                    [caption]="enumService.getFieldCaption('Adresse', 'adrBez')"
                                    class="span-6">
                      </exg-textarea>
                      <!--             <exg-textarea name="locComment" [maxlength]="1024" caption="{{getRessource('CaptionComment')}}" -->
                      <!--                           [(ngModel)]="AddressesList.oeAddressClone.adrComment"></exg-textarea> -->
                    </ng-container>
                  </div>
                  <div class="grid cols-6" *ngIf="showManuel">
                    <ng-container *ngIf="!predefinedAddressType">
                      <app-exg-select-enumeration #VCrcptTyp
                                                  [required]="true"
                                                  [(value)]="AddressesList.oeAddressClone.adr_enmIdent_AdresseTyp"
                                                  [caption]="enumService.getFieldCaption('Adresse', 'AdresseTyp')"
                                                  enumerationName="AdresseTyp"
                                                  name="type"
                                                  class="span-6">
                      </app-exg-select-enumeration>
                    </ng-container>

                    <exg-input [(ngModel)]="AddressesList.oeAddressClone.adrStr"
                               (ngModelChange)="resetGeoCode()"
                               [caption]="enumService.getFieldCaption('Adresse', 'adrStr')"
                               class="span-5">
                    </exg-input>
                    <exg-input [(ngModel)]="AddressesList.oeAddressClone.adrHNum"
                               (ngModelChange)="resetGeoCode()"
                               [caption]="enumService.getFieldCaption('Adresse', 'adrHNum')"
                               class="">
                    </exg-input>

                    <exg-input [(ngModel)]="AddressesList.oeAddressClone.adrZusatz"
                               (ngModelChange)="resetGeoCode()"
                               [caption]="enumService.getFieldCaption('Adresse', 'adrZusatz')"
                               class="span-6">
                    </exg-input>

                    <exg-input [(ngModel)]="AddressesList.oeAddressClone.adrLkz"
                               (ngModelChange)="resetGeoCode()"
                               [caption]="enumService.getFieldCaption('Adresse', 'adrLkz')"
                               class="">
                    </exg-input>
                    <exg-input [(ngModel)]="AddressesList.oeAddressClone.adrPlz"
                               (ngModelChange)="resetGeoCode()"
                               [caption]="enumService.getFieldCaption('Adresse', 'adrPlz')"
                               class="span-2">
                    </exg-input>
                    <exg-input [(ngModel)]="AddressesList.oeAddressClone.adrOrt"
                               (ngModelChange)="resetGeoCode()"
                               [caption]="enumService.getFieldCaption('Adresse', 'adrOrt')"
                               class="span-3">
                    </exg-input>

                    <exg-textarea [(ngModel)]="AddressesList.oeAddressClone.adrBez"
                                  [caption]="enumService.getFieldCaption('Adresse', 'adrBez')"
                                  class="span-6">
                    </exg-textarea>
                  </div>
                </div>
                <div class="spawn-reverse">
                  <button (click)="visibilityController.changeAddressEditor()"
                          class="md-btn">
                    {{getGlobal('Cancel')}}
                  </button>
                  <button (click)="addressAction({del: true})"
                          class="md-btn">
                    {{getGlobal('Delete')}}
                  </button>
                  <button (click)="changeManuel()"
                          class="md-btn">
                    {{showManuel ? getRessource('LocationSearchPlaceholder') : 'Manuelle Eingabe'}}
                  </button>
                  <button (click)="addressAction()"
                          class="md-btn">
                    {{getGlobal('Save')}}
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
		</div>
    <div *ngIf="isLoading" class="content height-800 width-900">
      <div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div>
    </div>
		<div class="spawn-modal-actions typo-small"
		     *ngIf="!showHintText">
      <button (click)="openCRM()"
              class="md-btn"
              *ngIf="OEDetails.oeID && excSecurity.isFeatured('CRMNAV')">
        {{getRessource('openCRM')}}
      </button>
      <button (click)="action()" class="md-btn" *ngIf="data.showAssignButton && OEDetails.oeID">
        {{getGlobal('Save')}}
      </button>
      <button (click)="close()" class="md-btn">
        {{getGlobal('Close')}}
      </button>
		</div>
		<div class="spawn-modal-actions typo-small"
		     *ngIf="showHintText">
			<div class="spawn" style="margin: 8px; font-size: 0.875rem; border: 2px solid var(--c-yellow-500); border-radius: 0.25rem; padding: 8px;">
				<i class="fa-solid fa-triangle-exclamation c-yellow fa-xl"
				   style="margin-right: .5rem"></i>
				{{getRessource('HintText')}}
			</div>

      <button (click)="doAction()" class="md-btn">
        {{getGlobal('Save')}}
      </button>
      <button (click)="showHintText = false" class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
		</div>
	</div>
</div>
